export const BASE_APP_PATH = "/";

export const route = (routePath?: string) => `${BASE_APP_PATH}${routePath}`;
